import { CroutonIds, GenericCroutonProps, ICroutonListData } from "@swiggy-private/cart-types";

export interface IGenericCrouton {
    setCroutonVisibility: (croutonVisibility: boolean) => void;
    canShowTimer?: boolean;
    uploadId?: string;
}

export interface BuildCroutonContentFromDataParams {
    data?: ICroutonListData;
    durationInSec?: number;
    setCroutonVisibility?: (croutonVisibility: boolean) => void;
}

export interface BuildCroutonRegistrationParams {
    type: CroutonIds;
    index: number;
    // Callers may pass extras (timerClassName, onCloseCrouton, timerKey) not yet on GenericCroutonProps.
    content: Partial<GenericCroutonProps> & Record<string, unknown>;
    forceRefreshContent?: boolean;
}

export const SUPPORTED_CROUTON_TYPES: CroutonIds[] = [
    CroutonIds.TIMED_FREE_CASH_CROUTON,
    CroutonIds.DEAL_RUSH,
    CroutonIds.MAGIC_ITEMS,
    CroutonIds.HOTEL_IN_ROOM_DELIVERY,
    CroutonIds.DELIVERY_SPEED_TOING,
    CroutonIds.TOING_LOOT_DEALS,
    // Backend only sends IPL_SWIGGY_SIXES in the crouton list for MRO carts.
    CroutonIds.IPL_SWIGGY_SIXES,
    CroutonIds.RX_CLOSING_TIMER,
    CroutonIds.MAGIC_ITEMS_TIMER_CROUTON,
];

/**
 * MRO only: crouton ids whose whole lifecycle is driven by the update-cart `croutonList`, so a
 * mounted one must be dropped as soon as a response stops backing it.
 *
 * IPL_SWIGGY_SIXES is excluded because useIPLSwiggySixesCroutonRegistration owns it: it keeps
 * ticking across cart refreshes and can be registered from a JS-bridge six hit with no list entry.
 */
export const MRO_CART_RESPONSE_DRIVEN_CROUTON_TYPES: CroutonIds[] = SUPPORTED_CROUTON_TYPES.filter(
    (croutonType) => croutonType !== CroutonIds.IPL_SWIGGY_SIXES,
);
